import {z} from 'zod';

import {Alpha2Enum} from '../../service/reivew-analysis/review-regions/reivew-regions-type';
import {FeaturesEnum} from '../../service/user/user-type';

export const brandSchema = z.object({
    id: z.number(),
    name: z.string(),
    isPossibleToCreateCompanyForUser: z.boolean().optional(),
    features: z
        .record(
            z.union([z.nativeEnum(FeaturesEnum), z.literal('source_settings_accounts')]),
            z.record(z.string(), z.boolean()).optional()
        )
        .optional(),
    counterpartyId: z.number().optional(),
    companyLicenceBalance: z.number().optional(),
});

export type BrandType = z.infer<typeof brandSchema>;

export const brandCountriesSchema = z.object({
    brandId: z.number(),
    countries: z.array(
        z.object({
            countryId: z.number(),
            alpha2: z.nativeEnum(Alpha2Enum),
            name: z.string(),
        })
    ),
});

export type BrandCountriesType = z.infer<typeof brandCountriesSchema>;
